// ContactPage.js
import React, { useState } from 'react';

const isImagePath = (str) =>
  typeof str === "string" && /\.(png|jpe?g|svg)$/.test(str);

export default function ContactPage({ animatedElements = {}, colors }) {
  const [isParkingModalOpen, setIsParkingModalOpen] = useState(false); // 新增這一行
  const localColors = colors || {
    primary: '#1a1a1a',
    secondary: '#4c956c',
    accent: '#d9f2b4',
    neutral: '#336F4D',
    neutralLight: '#505151',
    cream: '#fffaf0',
    gold: '#d4af37',
  };

  return (
    <section
      id="contact"
      className="contact-section animate-on-scroll"
      style={{
        padding: '6rem 2rem',
        background: `linear-gradient(180deg, rgba(248,250,245,0.9) 0%, rgba(217,242,180,0.2) 100%)`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative elements consistent with other sections */}
      <div
        className="decorative-element"
        style={{
          position: 'absolute',
          top: '15%',
          right: '5%',
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(76,149,108,0.05) 0%, rgba(255,255,255,0) 70%)',
          zIndex: 1
        }}
      />

      <div
        className="decorative-element"
        style={{
          position: 'absolute',
          bottom: '10%',
          left: '8%',
          width: '150px',
          height: '150px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(76,149,108,0.08) 0%, rgba(255,255,255,0) 70%)',
          zIndex: 1
        }}
      />

      <h2
        style={{
          fontSize: '2rem',
          fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
          marginBottom: '0.5rem',
          color: localColors.primary,
          position: 'relative',
          display: 'inline-block',
          animation: animatedElements['contact'] ? 'fadeInUp 1s ease forwards' : 'none',
          opacity: animatedElements['contact'] ? 1 : 0,
          fontWeight: 600,
          textAlign: 'center',
          width: '100%'
        }}
      >
        聯絡我們
        <div
          style={{
            width: '500px',
            height: '2px',
            background: 'linear-gradient(90deg, #5C8989, rgba(92, 137, 137, 0.3))',
            margin: '0.5rem auto 2rem',
            borderRadius: '1px',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: '-100%',
              width: '50%',
              height: '100%',
              background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
              animation: 'shine 3s infinite',
            }}
          />
        </div>
      </h2>

      <p
        style={{
          fontSize: '1.1rem',
          color: localColors.neutralLight,
          maxWidth: '600px',
          margin: '0 auto 3rem',
          lineHeight: '1.6',
          animation: animatedElements['contact'] ? 'fadeIn 1.2s ease 0.3s forwards' : 'none',
          opacity: animatedElements['contact'] ? 1 : 0,
          fontWeight: 600,
          textAlign: 'center'
        }}
      >
        為您提供專業服務，歡迎隨時與我們聯繫
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'stretch',
          maxWidth: '1200px',
          margin: '0 auto',
          gap: '2.5rem',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Left Side - Contact Info Card */}
        <div
          style={{
            flex: '1',
            minWidth: '300px',
            maxWidth: '500px',
            animation: animatedElements['contact'] ? 'fadeIn 1.2s ease 0.5s forwards' : 'none',
            opacity: animatedElements['contact'] ? 1 : 0,
          }}
        >
          <div
            style={{
              borderRadius: '16px',
              overflow: 'hidden',
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 12px 30px rgba(76, 149, 108, 0.15)',
              height: '100%',
              transition: 'transform 0.4s ease, box-shadow 0.4s ease',
              ':hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0 18px 40px rgba(76, 149, 108, 0.25)',
              }
            }}
          >
            <div style={{ padding: '2.5rem' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '2rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',

                }}
              >          <img
                  src="/assets/img/logo.jpg"
                  alt="JC Spa Logo"

                  style={{
                    width: '40px',
                    height: '40px',
                    marginRight: '0.75rem',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    flexShrink: 0,
                  }}
                />
                <h3
                  style={{
                    fontSize: 'clamp(1.4rem, 4vw, 1.8rem)',
                    fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
                    color: localColors.primary,
                    margin: 0,
                    fontWeight: 600,
                    position: 'relative',
                    display: 'inline-block',
                    whiteSpace: "nowrap",
                  }}
                >
                  京采再生美學SPA
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '-10px',
                      left: '0',
                      width: '80%',
                      height: '3px',
                      background: `linear-gradient(to right, ${localColors.secondary}, ${localColors.accent})`,
                      borderRadius: '2px',
                    }}
                  />
                </h3>

              </div>




              {/* Contact Info Items */}
              <div style={{ marginBottom: '2rem' }}>
                {[
                  {
                    icon: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z",
                    label: "電話",
                    value: "(02) 8596-1682",
                    link: "tel:+886285961682"
                  },
                  {
                    icon: "/assets/img/line.png", // ✅ 移除空格
                    label: "Line",
                    value: "@jingcaispa",
                    link: "https://page.line.me/535hsnpt?oat_content=url&openQrModal=true"
                  },
                  {
                    icon: "/assets/img/clock.png",
                    label: "營業時間",
                    value: "週一至週六 10:30-20:00",
                    link: null
                  },
                  {
                    icon: "/assets/img/placeholder.png",
                    label: "地址",
                    value: [
                      "台北市中山區天祥路61巷20號一樓",
                      "(民權西路捷運站9號出口左轉，八方雲集旁巷內一分鐘)"
                    ],
                    link: null
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '1.5rem',
                      transition: 'transform 0.3s ease',

                    }}
                  >
                    <div style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: `rgba(76, 149, 108, 0.1)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '1rem',
                      flexShrink: 0,
                    }}>
                      {isImagePath(item.icon) ? (
                        <img src={item.icon} alt={item.label} style={{ width: 22, height: 22, transform: 'translateY(2px)' }} />
                      ) : (
                        <svg width={22} height={22} viewBox="0 0 24 24" fill={localColors.secondary} style={{ transform: 'translateY(2px)' }}>
                          <path d={item.icon} />
                        </svg>
                      )}
                    </div>
                    <div>
                      <p style={{
                        fontSize: '0.9rem',
                        color: localColors.neutralLight,
                        marginBottom: '0.1rem',
                        textAlign: 'left',
                      }}>
                        {item.label}
                      </p>
                      {item.link ? (
                        <a
                          href={item.link}
                          style={{
                            display: 'block',
                            fontSize: '0.9rem',
                            color: item.value === "@jingcaispa" ? localColors.secondary : localColors.primary, // 🔵 改藍色                              textDecoration: 'none',
                            fontWeight: 500,
                            transition: 'color 0.3s ease',
                            textAlign: 'left',
                          }}
                        >
                          {Array.isArray(item.value)
                            ? item.value.map((line, idx) => (
                              <React.Fragment key={idx}>
                                {line}<br />
                              </React.Fragment>
                            ))
                            : item.value}
                        </a>
                      ) : (
                        <p style={{
                          fontSize: '1rem',
                          color: localColors.primary,
                          fontWeight: 500,
                          textAlign: "left",
                        }}>
                          {Array.isArray(item.value)
                            ? item.value.map((line, idx) => (
                              <React.Fragment key={idx}>
                                {line}<br />
                              </React.Fragment>
                            ))
                            : item.value}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>


              {/* Social Media Links */}
              <div>
                <p style={{
                  fontSize: '1rem',
                  color: localColors.neutralLight,
                  marginBottom: '1rem',
                  fontWeight: 500
                }}>
                  追蹤我們
                </p>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                  {[
                    {
                      name: "Facebook",
                      path: "M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z",
                      link: "https://www.facebook.com/people/%E4%BA%AC%E9%87%87%E5%86%8D%E7%94%9F%E7%BE%8E%E5%AD%B8spa/61565508795591/"
                    },
                    {
                      name: "Instagram",
                      path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
                      link: "https://www.instagram.com/jingcai_spa/"
                    }
                  ].map((social, i) => (
                    <a
                      key={i}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(76, 149, 108, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: localColors.secondary,
                        transition: 'all 0.3s ease',
                        ':hover': {
                          backgroundColor: localColors.secondary,
                          color: 'white',
                          transform: 'translateY(-3px)'
                        }
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d={social.path} />
                      </svg>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Map and Form Toggle */}
        <div
          style={{
            flex: '1',
            minWidth: '300px',
            maxWidth: '600px',
            alignSelf: 'center',
            animation: animatedElements['contact'] ? 'fadeIn 1.2s ease 0.7s forwards' : 'none',
            opacity: animatedElements['contact'] ? 1 : 0,
          }}
        >
          {/* 停車資訊 - 移到地圖上方 */}
          <div
            style={{
              borderRadius: '16px',
              overflow: 'hidden',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 12px 30px rgba(76, 149, 108, 0.15)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '1.5rem',
              marginBottom: '1.5rem',  // 和地圖之間的間距
            }}
          >
            <img
              src="/assets/img/parking.png"
              alt="停車資訊"
              onClick={() => setIsParkingModalOpen(true)}

              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                objectFit: 'contain',
                marginBottom: '0.75rem',
                cursor: 'pointer',
              }}
            />
            <h3 style={{
              fontSize: '1.2rem',
              color: localColors.primary,
              fontWeight: 600,
              margin: 0,
              fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
            }}>
              停車資訊
            </h3>
          </div>

          {/* 地圖 */}
          <div
            style={{
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 12px 30px rgba(76, 149, 108, 0.15)',
              height: '400px',
              position: 'relative',
              border: '1px solid rgba(76, 149, 108, 0.2)',
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1807.0689711930456!2d121.52065431545887!3d25.06331336267322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a95cf41e36cf%3A0x98d08bba37a43ea1!2z5Lqs6YeH5YaN55Sf576O5a24c3BhIOS4reWxseWNgOWBmuiHieaMieaRqeaOqOiWpijogLPnh6185bCP6aGP5pKl562LfOmgreearumkiuitt3zpq5TmhYvnrqHnkIZ86Z-T5ZyL6IiS6aGP5rOMfOmfk-Wci-WkluazjOmrlHznhKHnl5vmuIXnsonliLp86IKM6Iaa566h55CGfOayueWjkyk!5e0!3m2!1szh-TW!2stw!4v1753951714568!5m2!1szh-TW!2stw"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="京采再生美學Spa位置"
            />
          </div>

          {/* 立即預約按鈕 */}
          <a
            href="https://page.line.me/535hsnpt?oat_content=url&openQrModal=true"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <button
              className="cta-button"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: `linear-gradient(135deg, ${localColors.secondary}, ${localColors.neutral})`,
                border: 'none',
                borderRadius: '999px',
                padding: '0.85rem 2.5rem',
                color: 'white',
                fontWeight: 600,
                fontSize: '17px',
                cursor: 'pointer',
                boxShadow: '0 4px 15px rgba(76, 149, 108, 0.3)',
                fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                width: '80%',
                margin: '2rem auto 0',
              }}
            >
              立即預約
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                style={{ marginLeft: '0.5rem' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </button>
          </a>
        </div>

      </div>
      {isParkingModalOpen && (
        <div
          onClick={() => setIsParkingModalOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000,
          }}
        >
          <div style={{
            position: 'relative',
            maxWidth: '90%',
            maxHeight: '90vh',
          }}>
            <img
              src="/assets/img/parking.png"
              alt="停車資訊"
              style={{
                maxWidth: '100%',
                maxHeight: '90vh',
                objectFit: 'contain',
                borderRadius: '8px',
              }}
            />
            {/* 關閉按鈕 */}
            <button
              onClick={() => setIsParkingModalOpen(false)}
              style={{
                position: 'absolute',
                top: '-15px',
                right: '-15px',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'white',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                color: localColors.primary,
                boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </section >
  );
}
